import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mamografias',
  templateUrl: './mamografias.component.html',
  styleUrls: ['./mamografias.component.css']
})
export class MamografiasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
